// extracted by mini-css-extract-plugin
export default {"container":"BackToTopFloatButton_container__Iju-F","button":"BackToTopFloatButton_button__yO9rr","icon":"BackToTopFloatButton_icon__19NLV"};